<template>
    <div class="main-page signup login vh-100">
        <div class="container-fluid ps-0 h-100">

            <div class="row align-items-md-center row-eq-height mt-md-0 h-100" v-if="!moreInfo">
                <div class="col-md-5 h-100 login-bg vh-100">
                    <h3 class="nanosans mt-3 mt-md-5 pt-2 mb-md-3">تعلم اللغة الإنجليزية الآن ! </h3>
                    <div class="d-none d-md-inline">
                        <img src="../assets/images/login-leftimg.svg" alt="" class="img-fluid">
                    </div>
                    <img src="../assets/images/login-bg-mobile.svg" alt="" class="d-inline-block d-md-none img-fluid">
                </div>
                <div class="col-md-7 text-end px-5 content-login h-md-100 position-relative">
                    <HeaderMy class="d-none d-md-block text-end mb-5" />
                    <div class="alert alert-danger" v-if="this.errorMessage != ''">{{ errorMessage }}</div>
                    <div class="alert alert-danger" v-if="registerMessage">
                        رقم الجوال غير مسجل.
                        <a href="/signup" class="fw-bold text-dark">سجل الان</a>
                    </div>

                    <h1 class="pb-4 text-primarydark fw-bold dir-rtl nanosans mt-4 mt-md-0">دعنا نسجل دخولك!</h1>
                    <!-- {{ dialCode }} -->
                    <!-- {{ coutryCode }} -->
                    <Form @submit="login">
                        <div class="input-group mb-3">
                            <div class="input-group-text code-phone">
                                <!-- :preferredCountries="['iq', 'ae', 'om']" -->
                                <vue-country-code @onSelect="onSelect" defaultCountry="iq"
                                    v-model="myContryCode"></vue-country-code>
                                <!-- +961 <img src=".././assets/images/flaglebanon.svg"> -->
                            </div>
                            <Field ref="phoneInput" type="text" class="form-control" id="currentphone"
                                placeholder="رقم الهاتف المحمول" v-model="arabicNumber" name="email"
                                :rules="minRequired" @input="convertToEnglish" :maxlength="this.coutryCode" :disabled="loadingDiv" />


                            <ErrorMessage name="email" class="error w-100 text-danger mt-1" />
                        </div>

                        <div class="form-group mb-3 position-relative">
                            <Field :type="inputType" class="form-control passwrd" placeholder="كلمة المرور"
                                v-model="passwordss" name="password" :rules="passwordRules" />
                            <button class="btn btn-link passshow" @click="togglePasswordVisibility" type="button">
                                <img src=".././assets/images/eye-pass.svg" v-if="inputType === 'password'">
                                <img src=".././assets/images/eyeicon2.png" v-else>
                            </button>
                            <ErrorMessage name="password" class="error w-100 text-danger mt-1 d-block" />
                        </div>
                        <div class="form-group mb-3 forgetpass text-end nanosans">
                            <!-- <a href="#">هل نسيت كلمة الس؟</a> -->
                            <router-link to="/forgetpassword">
                                هل نسيت كلمة السر؟
                            </router-link>
                        </div>
                        <div class="input-groupb">
                            <button type="submit"
                                class="btn btn-main btn-lg py-3 w-100 mt-4 dir-rtl nanosans position-relative login-btn"
                                :disabled="loadingDiv || disablebtn">
                                <div class="spinner" v-if="loadingDiv"></div>
                                تسجيل
                                الدخول
                            </button>
                            <router-link to="/signup"
                                class="btn btn-signuplink btn-lg py-3 w-100 mt-4 dir-rtl nanosans position-relative login-btn">
                                ليس لديك حساب؟ <strong>اشترك الآن</strong>

                            </router-link>

                        </div>
                    </Form>

                    <!-- <vue-tel-input v-model="phone"></vue-tel-input> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import VueCountryCode from ".././components/VueCountryCode.vue";
import { Field, Form, ErrorMessage } from 'vee-validate';

import HeaderMy from '.././components/common/HeaderMy.vue'

import axios from 'axios';

export default {
    name: 'login-form',

    components: {
        VueCountryCode,
        Form,
        Field,
        ErrorMessage,
        HeaderMy
    },
    data() {
        return {
            inputType: 'password',
            name: '',
            phone: '',
            yourValue: '',
            showHimage: 'eye-pass.svg',
            arabicNumber: '',
            phonenumer: '',
            passwordss: '',
            errorMessage: '',
            codeNow: '',
            dialCode: '',
            moreInfo: false,
            loadingDiv: false,
            myContryCode: '',
            registerMessage: false,
            disablebtn: true,
            coutryCode: '',
            // messaging: getMessaging(firebaseApp),
            // currentToken: null,


        }
    },

    created() {
        const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
        if (isLoggedIn) {
            this.$router.push({ name: 'HomePage', query: { redirect: '/homepage' } });
        }
        // this.initFCM();

    },

    methods: {

        convertToEnglish() {

            const numericRegex = /^[0-9]*$/;
            if (!numericRegex.test(this.arabicNumber)) {
                // If it contains non-numeric characters, clear the field
                this.arabicNumber = this.arabicNumber.replace(/[^0-9]/g, '');
                setTimeout(() => {
                    document.getElementById("currentphone").value = this.arabicNumber;
                    // this.disablebtn = true
                });

            } else {
                // Convert Arabic numerals to English numerals
                const numerals = {
                    '٠': '0',
                    '١': '1',
                    '٢': '2',
                    '٣': '3',
                    '٤': '4',
                    '٥': '5',
                    '٦': '6',
                    '٧': '7',
                    '٨': '8',
                    '٩': '9',
                };

                let convertedNumber = '';

                for (let i = 0; i < this.arabicNumber.length; i++) {
                    const char = this.arabicNumber[i];
                    convertedNumber += numerals[char] || char;
                }

                this.arabicNumber = convertedNumber;
            }
            if (this.arabicNumber.length > 15) {
                this.arabicNumber = this.arabicNumber.slice(0, 15);


            }

            if (this.arabicNumber.length === this.coutryCode) {
                this.disablebtn = false;
            } else {
                this.disablebtn = true;
            }

        },


        isRequired(value) {

            if (!value) {
                return 'هذه الخانة مطلوبه';
            }
            return true;
        },
        minRequired(value) {
            if (!value) {
                return 'هذه الخانة مطلوبه';
            }
            if (!/^\d{5,}$/.test(value)) {
                return 'أدخل رقم هاتف صالح';
            }
            return true;
        },
        passwordRules(value) {
            // Password validation rules
            const minLength = 2;

            if (!value) {
                return 'كلمة المرور مطلوبة';
            } else if (value.length < minLength) {
                return `كلمة المرور يجب أن تحتوي على ${minLength} أحرف على الأقل`;
            }

            return true;
        },

        togglePasswordVisibility() {
            this.inputType = this.inputType === 'password' ? 'text' : 'password';
            // this.showHimage = this.showHimage === 'eye-pass.svg' ? 'eye-pass.svg' : 'eye-pass.svg';
        },
        async onSelect({ dialCode, iso2 }) {
            this.disablebtn = true;
            this.arabicNumber = '';
            this.dialCode = dialCode ? dialCode.replace('+', '') : '';
            this.loadingDiv = true;
            const coutryCode = iso2;
            try {
                const response = await axios.get('https://backend.nadyalloughat.com/api/check-country-digits/' + coutryCode, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        // mode: 'no-cors',
                    }
                });
                this.coutryCode = response.data.digits_length;


            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loadingDiv = false; // Set isLoading to false when data is fetched (or on error)
                this.$nextTick(() => {
                    if (this.$refs.phoneInput) {
                        // For Vee-Validate Field component, you might need to access the input element
                        const inputElement = this.$refs.phoneInput.$el || this.$refs.phoneInput;
                        if (inputElement && inputElement.focus) {
                            inputElement.focus();
                        }
                    }
                });
            }

        },

        async login() {
            this.loadingDiv = true;
            try {
                // const myConstantIs = document.getElementsByClassName('country-code')[0].innerText;
                const response = await axios.post('https://backend.nadyalloughat.com/api/login', {
                    // country: this.dialCode,
                    login: this.dialCode + this.arabicNumber,
                    password: this.passwordss,
                });

                if (response.status === 200 || response.status === 201) {
                    // Login successful, handle the response (e.g., store user data)
                    localStorage.setItem('token', response.data.user.token);
                    localStorage.setItem('userData', JSON.stringify(response.data.user));


                    if (response.data.user.name === null) {
                        this.$router.push({ name: 'LoginInfo', query: { redirect: '/login-info' } });
                    } else {
                        this.$router.push({ name: 'HomePage', query: { redirect: '/homepage' } });
                    }
                }
                if (response.status === 400) {
                    this.errorMessage = 'اعتماد تسجيل الدخول غير صالح';
                    this.registerMessage = false;
                }

            } catch (error) {
                // Handle network or other errors
                console.error('Error during login:', error.response.data);
                this.errorMessage = 'اعتماد تسجيل الدخول غير صالح';
                this.registerMessage = false;

                if (error.response.data.error_code === 101) {
                    this.registerMessage = true;
                    this.errorMessage = '';
                }
                if (error.response.data.error_code === 102) {
                    this.registerMessage = false;
                    this.errorMessage = error.response.data.message;
                }

            } finally {
                // this.errorMessage = 'اعتماد تسجيل الدخول غير صالح';
                this.loadingDiv = false; // Set isLoading to false when data is fetched (or on error)
            }
        }
    }
}

</script>

<style>
@media screen and (max-width:767px) {
    html body {
        height: 87vh !important;
    }
}
</style>